// src/docs/DocsOverview.js
import React from "react";
import { Container, Typography, Box } from "@mui/material";
import { Helmet } from "react-helmet";
import { useEffect } from "react";

const DocsOverview = () => {

  

   <Helmet>
    <title>CrowdLaunch Docs</title>
    <meta name="description" content="Your page description" />
    {/* Global Site Tag (gtag.js) - Google Analytics */}
    <script async src="https://www.googletagmanager.com/gtag/js?id=G-W97PQD73RV"></script>
    <script>
      {`
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'G-W97PQD73RV', { page_path: window.location.pathname });
      `}
    </script>
  </Helmet>

  useEffect(() => {
    if (window.gtag) {
      window.gtag('config', 'G-W97PQD73RV', {
        page_path: window.location.pathname,
      });
    }
  }, []);
  
  
  return (
    <Container maxWidth="md" sx={{ my: 4 }}>
      <Typography variant="h5" sx={{ color: "#FFD700", mb: 2 }}>
        CrowdLaunch Documentation
      </Typography>

      <Typography variant="body1" sx={{ color: "#FFFFFF", mb: 2 }}>
        Welcome to CrowdLaunch! This documentation will help you understand
        how our platform works, with a focus on project tokenization,
        financing, and the secondary marketplace. New topics will be periodically added here.
      </Typography>
        <Typography variant="body1" sx={{ color: "#FFFFFF", mb: 1 }}>
          CrowdLaunch is a decentralized platform where project owners can
          tokenize their projects and raise capital through token sales.
          Investors can participate by buying tokens, and later trade these
          tokens on a secondary marketplace.
        </Typography>
    </Container>
  );
};

export default DocsOverview;
